import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { ReactQueryProvider } from "services/reactQuery";
import { router } from "./router";

import "./styles/index.scss";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ReactQueryProvider>
    <RouterProvider router={router} />
  </ReactQueryProvider>
);
